module.exports = __webpack_public_path__ + "img/icon-apps-enable.336035d2.svg";